import { Button } from '@/components/button';
import { IconName } from '@/components/material-symbol-link';
import { TranslationKey } from '@/contexts/translations';
import { ReactNode } from 'react';

export type Mode = 'create' | 'edit';

export interface DemographicsConfig {
  title: string;
  navigationButton: {
    textKey: TranslationKey;
    route: string;
  };
  showStepper: boolean;
  showTextMeSection: boolean;
  validateAge?: boolean;
  submitButton: {
    textKey: TranslationKey;
    icon?: IconName;
  };
  nextStep?: string;
  nextRoute: string;
  secondaryButton?: ReactNode;
}

export const getPatientCreationConfig = (
  t: (key: TranslationKey) => string,
  withSurrogate: boolean,
): DemographicsConfig => ({
  title: t('patientProfile.pageTitle'),
  navigationButton: {
    textKey: 'common.previousStep',
    route: '/profile/type-selection',
  },
  showStepper: true,
  showTextMeSection: !withSurrogate,
  validateAge: true,
  submitButton: {
    textKey: withSurrogate ? 'common.next' : 'patientProfile.completeBtn',
    icon: withSurrogate ? 'arrow_forward' : undefined,
  },
  nextStep: withSurrogate ? t('patientProfile.nextStep') : undefined,
  nextRoute: withSurrogate ? '/profile/surrogate' : '/profile/review',
});

export const getPatientEditConfig = (t: (key: TranslationKey) => string): DemographicsConfig => ({
  title: t('patientProfile.pageEditTitle'),
  navigationButton: {
    textKey: 'common.back',
    route: '/profile/information',
  },
  showStepper: false,
  showTextMeSection: false,
  validateAge: false,
  submitButton: {
    textKey: 'common.saveChanges',
  },
  nextRoute: '/profile/information',
  secondaryButton: (
    <Button variant="outlined" color="accent" as="a" to="/profile/information">
      {t('common.cancel')}
    </Button>
  ),
});

export const getSurrogateCreationConfig = (
  t: (key: TranslationKey) => string,
): DemographicsConfig => ({
  title: t('surrogate.pageTitle'),
  navigationButton: {
    textKey: 'common.previousStep',
    route: '/profile/patient-info',
  },
  showStepper: true,
  showTextMeSection: true,
  submitButton: {
    textKey: 'surrogate.completeProfile',
  },
  nextRoute: '/profile/review',
});

export const getSurrogateEditConfig = (t: (key: TranslationKey) => string): DemographicsConfig => ({
  title: t('surrogate.pageTitle'),
  navigationButton: {
    textKey: 'common.back',
    route: '/profile/information',
  },
  showStepper: false,
  showTextMeSection: false,
  submitButton: {
    textKey: 'common.saveChanges',
  },
  nextRoute: '/profile/information',
  secondaryButton: (
    <Button variant="outlined" color="accent" as="a" to="/profile/information">
      {t('common.cancel')}
    </Button>
  ),
});
